module.exports = __webpack_public_path__ + "media/images/head-03815c193211b2d74a6e0549cb0b27db.png";